<template>
  <layout-content>
    <template #toolbar>
      <el-date-picker
        v-model="beginTime"
        :picker-options="startDatePickerOptions"
        size="small"
        type="month"
        :editable="false"
        :clearable="false"
        placeholder="开始时间"
        value-format="yyyy-MM-dd 00:00:00"
        style="width:170px;"
        @change="dateChange"
      >
      </el-date-picker>
      <span>～</span>
      <el-date-picker
        v-model="endTime"
        :picker-options="endDatePickerOptions"
        :editable="false"
        :clearable="false"
        placeholder="结束时间"
        value-format="yyyy-MM-dd 23:59:59"
        type="month"
        size="small"
        style="width:170px;"
        @change="dateChange()"
      />

      <el-button
        :disabled="canNotSearch"
        type="orange"
        size="small"
        icon="el-icon-search"
        @click="getData"
      >查询</el-button>
      <el-button
        :disabled="canNotSearch"
        type="success"
        size="small"
        icon="el-icon-download"
        @click="onDownloadBtnClick"
      >导出</el-button>
    </template>

    <template #body>
      <data-wrapper>
        <template #header>
          <div style="flex:1;padding:0 12px;"></div>
          <el-radio-group v-model="query.isSiteMerge" size="small" @change="getData">
            <el-radio-button :label="true">聚合综合指数</el-radio-button>
            <el-radio-button :label="false">站点综合指数</el-radio-button>
          </el-radio-group>

          <completed-query v-model="query.isAuditCompleted" :is-show-fuse="false" @change="getData"/>

          <div style="position:relative;flex:1;display:flex;justify-content:flex-end;padding:0 12px;">
            <PassLegend />
          </div>
        </template>

        <sidebar-content sidebarWidth="180px" title="站点选择">
          <template #silder-header-toolbar>
            <select-ctrl-group
              :ids="query.siteIds"
              :options="filterSites"
              show-icon
              style="padding-bottom:0;"
              @change="onSelectCtrlChange"
            />
          </template>

          <template #sidebar-body>
            <div class="device-dropdown-selector-wrapper">
              <div class="device-dropdown-selector-wrapper-inner">
                <el-tree
                  ref="site-tree"
                  :data="filterSites"
                  :props="{
                    value: 'id',
                    label: 'name'
                  }"
                  node-key="id"
                  show-checkbox
                  check-on-click-node
                  accordion
                  :default-checked-keys="query.siteIds"
                  @check="onSiteCheckChange"
                />
                <!-- <div
                  v-for="site in filterSites"
                  :key="site.id"
                  class="device-dropdown-selector"
                >
                  <el-checkbox v-model="query.siteIds" :label="site.id" @change="getData">{{site.name}}</el-checkbox>
                </div> -->
              </div>
            </div>
          </template>

          <template #sidebar-content-body>
            <el-table
              ref="elTable"
              :data="dataList"
              height="100%"
              border
              header-row-class-name="custom-table-header"
              style="width: 100%"
            >
              <el-table-column
                v-for="(column, index) in baseHeaderColumns"
                :key="`base-${index}`"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :align="column.align || 'left'"
              />

              <el-table-column label="平均浓度" align="center">
                <el-table-column
                  v-for="(column, index) in avgHeaderColumns"
                  :key="`avg-${index}`"
                  :label="column.label"
                  width="100"
                  align="center"
                >
                  <template slot="header" slot-scope="scope">
                    <div class="factor-table-header">
                      <span>{{ column.label }}</span>
                      <span>{{ column.unit }}</span>
                    </div>
                  </template>

                  <template slot-scope="{ row }">
                    <div :is-pass="Number((row.avg[column.prop] || {}).isPass)" class="factor-pass-value">{{ (row.avg[column.prop] || {}).value }}</div>
                  </template>
                </el-table-column>
              </el-table-column>

              <el-table-column label="百分位数" align="center">
                <el-table-column
                  v-for="(column, index) in perHeaderColumns"
                  :key="`per-${index}`"
                  :label="column.label"
                  width="120"
                  align="center"
                >
                  <template slot="header" slot-scope="scope">
                    <div class="factor-table-header">
                      <span>{{ column.label }}</span>
                      <span>{{ column.unit }}</span>
                    </div>
                  </template>

                  <template slot-scope="{ row }">
                    <div :is-pass="Number((row.per[column.prop] || {}).isPass)" class="factor-pass-value">{{ (row.per[column.prop] || {}).value }}</div>
                  </template>
                </el-table-column>
              </el-table-column>

              <el-table-column label="优良率" align="center">
                <el-table-column
                  v-for="(column, index) in goodHeaderColumns"
                  :key="`good-${index}`"
                  :prop="column.prop"
                  :label="column.label"
                  width="100"
                  align="center"
                />
              </el-table-column>

              <el-table-column label="综合指数" align="center">
                <el-table-column
                  v-for="(column, index) in compositeHeaderColumns"
                  :key="`index-${index}`"
                  :prop="column.prop"
                  :label="column.label"
                  width="100"
                  align="center"
                />
              </el-table-column>
            </el-table>
          </template>
        </sidebar-content>
      </data-wrapper>
    </template>
  </layout-content>
</template>

<script>
import BaseFactorData from '../../../BaseFactorData'
import LayoutContent from '../../../../components/Layout/Content'
import DataTable from '../../../../components/Data/DataTable'
import CSVDownloader from '../../../../utils/CSVDownloader'
import PassLegend from '../../../../components/Legend/PassLegend.vue'
export default {
  name: 'DataManagementCompositeIndex',
  routeInfo: {
    label: '月度统计'
  },
  extends: BaseFactorData,
  components: { LayoutContent, DataTable, PassLegend },
  data () {
    return {
      beginTime: new Date().format('YYYY-MM-DD 00:00:00'),
      endTime: new Date().format('YYYY-MM-DD 23:59:59'),
      query: {
        factorIds: [1001, 1003, 1005, 1006, 1007, 1008],
        isAuditCompleted: false, // finished
        isSiteMerge: true
      },
      activeName: 'merge',
      flag: {
        merge: true,
        site: false
      },
      dataTableKey: 0,
      headerColumns: [],
      baseHeaderColumns: Object.freeze([]),
      avgHeaderColumns: Object.freeze([]),
      perHeaderColumns: Object.freeze([]),
      goodHeaderColumns: Object.freeze([]),
      compositeHeaderColumns: Object.freeze([]),
      dataList: [],
      siteDataList: [],
      pagination: {
        no: 1,
        size: 24
      },
      csvData: [],
      unitProp: 'stdUnit'
    }
  },
  computed: {
    startDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() > new Date(this.query.endTime)
      }
    },
    endDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() < new Date(this.query.beginTime)
      }
    }
  },
  methods: {
    dateChange () {
      let {beginTime, endTime} = this
      this.query.beginTime = new Date(beginTime).format('YYYY/MM/01 00:00:00')
      let temp = new Date(endTime)
      let y = temp.getFullYear()
      let m = temp.getMonth() + 1
      this.query.endTime = new Date(y, m, 0).format('YYYY/MM/DD 23:59:59')
    },
    getData () {
      this.dataTableKey = 0
      this.dateChange()
      let {query} = this
      if (query.siteIds.length === 0) {
        return
      }

      this.changeLoadStatus(true)
      Promise.all([
        this.$api.Aqi.getComposite(query),
        this.$api.Aqi.getConcentration(query)
      ]).then(([compositeData, concData]) => {
        // this.formatData(backData)
        // this.resetPagination()
        // this.renderData()
        this.currentQuery = JSON.parse(JSON.stringify(query))
        this.formatData(compositeData, concData)

        setTimeout(() => {
          this.$refs.elTable.doLayout()
        }, 20)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    formatData (compositeData, concData) {
      let { currentQuery } = this

      // 开始：基本列
      const baseHeaderColumns = [{
        prop: 'dataTime',
        label: '时间',
        width: 180,
        align: 'center',
        fixed: true
      }]

      const { isSiteMerge } = currentQuery
      if (!isSiteMerge) {
        baseHeaderColumns.push({
          prop: 'siteName',
          label: '站点',
          fixed: true
        })
      }

      this.baseHeaderColumns = Object.freeze(baseHeaderColumns)
      // 结束：基本列

      // 开始：需要展示的因子
      const queryFactorIds = currentQuery.factorIds
      const factorIdMap = queryFactorIds.reduce((map, factorId) => {
        map[factorId] = true
        return map
      }, {})
      const querySiteIds = currentQuery.siteIds
      const siteIdMap = querySiteIds.reduce((map, siteId) => {
        map[siteId] = true
        return map
      }, {})

      const displayFactorMap = this.sites
        .filter(site => siteIdMap[site.id])
        .reduce((map, site) => site.devices.reduce((map, device) =>
          device.siteDeviceFactors.reduce((map, factor) => {
            const { factorId } = factor
            if (factorIdMap[factorId] && !map[factorId]) {
              map[factorId] = factor
            }
            return map
          }, map), map), {})

      const displayFactors = queryFactorIds.reduce((list, factorId) => {
        const factor = displayFactorMap[factorId]
        if (factor) {
          list.push(factor)
        }
        return list
      }, [])
      // 结束：需要展示的因子

      const { unitProp } = this

      // 开始：平均浓度列
      this.avgHeaderColumns = Object.freeze(displayFactors.reduce((list, factor) => {
        const { factorId } = factor
        if (factorId !== '1006') {
          list.push({
            prop: factorId,
            label: factor.name,
            unit: factor[unitProp]
          })
        }

        return list
      }, []))
      // 结束：平均浓度列

      // 开始：百分位数列
      const nameSuffixMap = {
        1001: '98per',
        1003: '98per',
        1005: '95per',
        1006: '90per',
        1007: '95per',
        1008: '95per'
      }
      this.perHeaderColumns = Object.freeze(displayFactors.map(factor => ({
        prop: factor.factorId,
        label: `${factor.name}${factor.factorId === '1006' ? '_8H' : ''}-${nameSuffixMap[factor.factorId]}`,
        unit: factor[unitProp]
      })))
      // 结束：百分位数列

      // 开始：优良率列
      this.goodHeaderColumns = [{
        prop: `good`,
        label: 'AQI'
      }]
      // 结束：优良率列

      // 开始：综合指数
      const compositeHeaderColumns = displayFactors.map((factor) => ({
        prop: `index.${factor.factorId}`,
        label: factor.name
      }), [])
      compositeHeaderColumns.push({
        prop: 'index.index',
        label: '综合指数'
      })
      this.compositeHeaderColumns = Object.freeze(compositeHeaderColumns)
      // 结束：综合指数

      // 开始：整理数据
      const perReg = /per$/
      const { factorMap, profileSiteMap } = this
      const dataMap = concData.reduce((map, data) => {
        const { dataTime } = data
        let dateDataMap = map[dataTime]
        if (!dateDataMap) {
          dateDataMap = map[dataTime] = {}
        }

        const siteId = data.siteId || 'ALL_SITE'
        let siteDataMap = dateDataMap[siteId]
        if (!siteDataMap) {
          siteDataMap = dateDataMap[siteId] = {
            dataTime,
            siteId,
            siteName: (profileSiteMap[siteId] || {name: ''}).name,
            avg: {},
            per: {},
            index: {}
          }
        }

        const { rootFactorId, factorId } = data
        const factor = factorMap[factorId] || {decimalNum: 2}
        const { decimalNum = 2 } = factor
        let { value } = data
        value = Number.isFinite(value) ? Number(value.toFixed(decimalNum)) : null
        if (perReg.test(rootFactorId)) {
          const { per } = siteDataMap
          per[factorId] = {
            isPass: data.isPass,
            value
          }
        } else if (factorId === 'AQI') {
          siteDataMap.good = Number.isFinite(value) ? `${value}%` : ''
        } else {
          const { avg } = siteDataMap
          avg[data.factorId] = {
            isPass: data.isPass,
            value
          }
        }

        return map
      }, {})

      compositeData.reduce((map, data) => {
        const { dataTime } = data
        let dateDataMap = map[dataTime]
        if (!dateDataMap) {
          dateDataMap = map[dataTime] = {}
        }

        const siteId = data.siteId || 'ALL_SITE'
        let siteDataMap = dateDataMap[siteId]
        if (!siteDataMap) {
          siteDataMap = dateDataMap[siteId] = {
            dataTime,
            siteId,
            siteName: (profileSiteMap[siteId] || {name: ''}).name,
            avg: {},
            per: {},
            index: {
              index: null
            }
          }
        }

        const { index } = siteDataMap
        const { value } = data
        if (Number.isFinite(value)) {
          index[data.factorId] = Number(value.toFixed(2))
          index.index = (index.index || 0) + value
        }

        return map
      }, dataMap)

      this.dataList = Object.freeze(Object.values(dataMap).reduce(
        (list, dateDataMap) => Object.values(dateDataMap).reduce(
          (list, siteDataMap) => {
            const { index } = siteDataMap
            const indexValue = index.index
            if (Number.isFinite(indexValue)) {
              index.index = Number(indexValue.toFixed(2))
            }
            list.push(siteDataMap)
            return list
          }, list), []).sort((a, b) => a.dataTime.localeCompare(b.dataTime) || a.siteName.localeCompare(b.siteName)))
      // 结束：整理数据
    },
    resetPagination () {
      let {pagination, value} = this
      pagination.no = 1
      pagination.size = value === 24 ? 30 : 24
    },
    renderData () {
      this.$nextTick(() => {
        if (this.query.isSiteMerge) {
          this.$refs.dataTable.doLayout()
        } else {
          let dataTables = this.$refs.dataTables
          dataTables.forEach(dataTable => dataTable.doLayout())
        }
      })
    },
    setSVGHeader (mainTitle, columns, headerGroups, headerColumns, hasPass) {
      headerGroups.push(mainTitle)
      headerColumns.push(columns[0].label)
      if (hasPass) {
        headerGroups.push('')
        headerColumns.push('')
      }

      const len = columns.length
      for (let i = 1; i < len; i++) {
        headerGroups.push('')

        const column = columns[i]
        let { label } = column
        if (column.hasOwnProperty('unit')) {
          label += `\n${column.unit}`
        }
        headerColumns.push(label)

        if (hasPass) {
          headerGroups.push('')
          headerColumns.push('')
        }
      }
    },
    onDownloadBtnClick () {
      const rows = []
      const headerGroups = []
      const headerColumns = []

      const { baseHeaderColumns } = this
      this.setSVGHeader('', baseHeaderColumns, headerGroups, headerColumns)

      let { currentQuery } = this
      const { isSiteMerge } = currentQuery
      const { avgHeaderColumns } = this
      this.setSVGHeader('平均浓度', avgHeaderColumns, headerGroups, headerColumns, !isSiteMerge)

      const { perHeaderColumns } = this
      this.setSVGHeader('百分位数', perHeaderColumns, headerGroups, headerColumns, !isSiteMerge)

      const { goodHeaderColumns } = this
      this.setSVGHeader('优良率', goodHeaderColumns, headerGroups, headerColumns)

      const { compositeHeaderColumns } = this
      this.setSVGHeader('综合指数', compositeHeaderColumns, headerGroups, headerColumns)

      rows.push(headerGroups, headerColumns)

      const { dataList } = this
      dataList.forEach(data => {
        const dataColumns = []
        baseHeaderColumns.forEach(column => {
          dataColumns.push(data[column.prop])
        })

        avgHeaderColumns.forEach(column => {
          const avgData = data.avg[column.prop] || {value: ''}
          dataColumns.push(Number.isFinite(avgData.value) ? avgData.value : '')
          if (!isSiteMerge) {
            dataColumns.push(avgData.isPass ? '满足' : (avgData.isPass === false ? '未满足' : ''))
          }
        })

        perHeaderColumns.forEach(column => {
          const perData = data.per[column.prop] || {value: ''}
          dataColumns.push(Number.isFinite(perData.value) ? perData.value : '')
          if (!isSiteMerge) {
            dataColumns.push(perData.isPass ? '满足' : (perData.isPass === false ? '未满足' : ''))
          }
        })

        goodHeaderColumns.forEach(column => {
          dataColumns.push(data[column.prop])
        })

        compositeHeaderColumns.forEach(column => {
          const indexData = data.index || {}
          dataColumns.push(indexData[column.prop.replace('index.', '')] || '')
        })

        rows.push(dataColumns)
      })

      let { beginTime, endTime } = currentQuery
      let csvName = `${new Date(beginTime).format('YYYY年MM月')}_${new Date(endTime).format('YYYY年MM月')}综合指数_${isSiteMerge ? '聚合' : '站点'}`
      CSVDownloader(rows, csvName)
    },
    onSiteCheckChange () {
      let checkedSiteList = this.getSiteTree().getCheckedNodes()
      this.query.siteIds = checkedSiteList.filter(item => !Array.isArray(item.children)).map(item => item.id)
      this.getData()
    },
    setCheckedKeys (siteIds) {
      let siteTree = this.getSiteTree()

      if (siteTree) {
        siteTree.setCheckedKeys(siteIds)
        this.getData()
      }
    },
    getSiteTree () {
      return this.$refs['site-tree']
    },
    onSelectCtrlChange (ids) {
      this.setCheckedKeys(ids)
    }
  },
  created () {
    let dateObj = new Date()
    let y = dateObj.getFullYear()
    let m = dateObj.getMonth() + 1
    this.query.beginTime = new Date().format('YYYY/MM/01 00:00:00')
    this.query.endTime = new Date(y, m, 0).format('YYYY/MM/DD 23:59:59')
    delete this.query.dataType
  }
}
</script>

<style lang="scss" scoped>
.site-selector {
  line-height: 1.7;
  -webkit-font-smoothing: antialiased;
}

.tree-popover-wrapper {
  max-height: 300px;
  overflow: auto;
}

.data-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  .site-data {
    & + .site-data {
      margin-top: 20px;
    }
  }

  .site-data-header {
    line-height: 1.8em;
    padding: 0 10px;
    background: -webkit-gradient(linear, left top, right top, from(#fbc15a), to(#fff));
    background: linear-gradient(to right, #fbc15a 0%, #fff 100%);
    color: #ffffff;
    font-weight: 600;
  }

  .site-data-body {
    height: 400px;
  }
}
.device-dropdown-selector-wrapper {
  display: grid;
  // grid-template-rows: auto 1px max-content;
  grid-template-rows: max-content auto;
  height: 400px;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .device-dropdown-selector-wrapper-inner {
    padding: 12px 0;
    overflow: auto;
  }

  .device-dropdown-selector {
    line-height: 1.7;
    -webkit-font-smoothing: antialiased;
  }
}

.factor-table-header {
  display: flex;
  flex-direction: column;
  text-align: center;
  line-height: 1.2;
}

.legend-list {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/02Normal/10Composite-Index/index.vue